import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"
import { NumericInput } from './fields'
import { getFormName, getTemplateSize } from "../forms/helpers"
import { AlternativeTemplate, Template } from 'app/types/model-types'

import {
    css,
    Grid,
    GridCell,
    Range,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue as change,
    selectFormValues,
} from "app/reducers/form";
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

const {round} = Math

interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    change: typeof change
}

class SourceImagePositionAndRotationForm extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)
        const templateSize = getTemplateSize()

        return (
            <React.Fragment>
                <FieldLabel>{trans('position')}</FieldLabel>
                <Grid cols="1fr 1fr" gap="20px">
                    <GridCell style={{ position: 'relative' }}>
                        <NumericInput
                            formName={formName}
                            fieldName={'translate_x'}
                            placeholder={'X'}
                            id={'x-pos'}
                            min={0}
                            max={templateSize.width}
                            step={10}
                            value={round(form.translate_x)}
                        />
                    </GridCell>
                    <GridCell style={{ position: 'relative' }}>
                        <NumericInput
                            formName={formName}
                            fieldName={'translate_y'}
                            placeholder={'Y'}
                            id={'y-pos'}
                            min={0}
                            max={templateSize.height}
                            step={10}
                            value={round(form.translate_y)}
                        />
                    </GridCell>
                    <GridCell col={'1/-1'}>
                        <Range
                            label={trans('rotation')}
                            name={`${formName}.rotation`}
                            defaultValue={0}
                            min={-360}
                            max={360}
                            step={1}
                            onClear={() => this.props.change(formName, 'rotation', 0)}
                        />
                    </GridCell>
                </Grid>
            </React.Fragment>
        )
    }
}


function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
    }
}

export default connect(mapStateToProps, {
    change,
})(SourceImagePositionAndRotationForm)
